class ProductForm extends HTMLElement {
  static cartSections = ['cart-drawer', 'cart-icon-bubble', 'cart-live-region-text'];

  constructor() {
    super();
    this.form = this.querySelector('form');
    this.submitButton = this.querySelector('[type="submit"]');
    this.spinner = this.querySelector('.loading__spinner');
    this.errorWrapper = this.querySelector('.product-form__error-message-wrapper');
    this.errorMessage = this.querySelector('.product-form__error-message');
    this.hideErrors = this.dataset.hideErrors === 'true';

    this.form?.addEventListener('submit', this.onSubmit.bind(this));
  }

  onSubmit(event) {
    event.preventDefault();
    if (this.submitButton?.getAttribute('aria-disabled') === 'true') return;

    const variantInput = this.querySelector('.product-variant-id');
    if (variantInput && !variantInput.value) {
      this.openVariantSelector();
      return;
    }

    this.clearError();
    this.setLoading(true);

    const formData = new FormData(this.form);
    formData.set('quantity', '1');
    formData.append('sections', ProductForm.cartSections.join(','));
    formData.append('sections_url', window.location.pathname);

    fetch(this.dataset.cartAddUrl, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status) {
          throw new Error(data.description || data.message || 'Unable to add to cart');
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          cartData: data,
          fallbackImage: this.dataset.productImage,
        });

        if (data.sections) ProductForm.updateSections(data.sections);
      })
      .catch((error) => {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          errors: error.message,
        });
        this.showError(error.message);
      })
      .finally(() => {
        this.setLoading(false);
      });
  }

  openVariantSelector() {
    const variantSelects = document.querySelector(`variant-selects[data-section="${this.dataset.sectionId}"]`);
    const optionSelector =
      variantSelects?.querySelector('option-selector:not(:has(input:checked))') ||
      variantSelects?.querySelector('option-selector');
    optionSelector?.open();
  }

  setLoading(loading) {
    this.classList.toggle('product-form--loading', loading);
    this.submitButton?.toggleAttribute('aria-disabled', loading);
    this.spinner?.classList.toggle('hidden', !loading);
  }

  clearError() {
    if (!this.errorWrapper) return;
    this.errorWrapper.hidden = true;
    if (this.errorMessage) this.errorMessage.textContent = '';
  }

  showError(message) {
    if (this.hideErrors || !this.errorWrapper) return;
    this.errorWrapper.hidden = false;
    if (this.errorMessage) this.errorMessage.textContent = message;
  }

  static updateSections(sections) {
    Object.entries(sections).forEach(([sectionId, html]) => {
      // cart-drawer refreshes itself (see cart-drawer.js) so that its
      // open dialog state survives — replacing it here would blow away
      // the instance the cart-update subscriber just opened.
      if (sectionId === 'cart-drawer') return;

      const targets = document.querySelectorAll(`[data-section-updates="${sectionId}"]`);
      if (!targets.length) return;

      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const newContent = parsed.querySelector('.shopify-section');
      if (!newContent) return;

      targets.forEach((target) => {
        target.innerHTML = newContent.innerHTML;
      });
    });
  }
}

customElements.define('product-form', ProductForm);
